import { initFaqAccordion } from '../animation/faqAccordion.js';

// Industry詳細: FAQアコーディオン（共通モジュールをこのページのスコープに適用）
function init() {
  initFaqAccordion('.p-industry-detail__faq');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
